(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hb-final-cta"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var a = e.target.closest('[data-hb-buy]');
  if (!a) return;
  var bb = document.querySelector('[id^="shopify-section-"][id*="hyt_buybox"]')
        || document.querySelector('.hyt-bb-root');
  if (!bb) return;
  e.preventDefault();
  e.stopPropagation();
  bb.scrollIntoView({ behavior: 'smooth', block: 'start' });
}, true);

  } catch(e) { console.error(e); }
})();
})();
